var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmationFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small/confirmation-filled",
    clipPath: "url(#clip0_3254_1241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM12.0881 5.24805L7.97486 10.9512C7.91737 11.0314 7.84158 11.0968 7.75378 11.1419C7.66597 11.187 7.56868 11.2105 7.46997 11.2105C7.37126 11.2105 7.27397 11.187 7.18617 11.1419C7.09837 11.0968 7.02258 11.0314 6.96509 10.9512L4.52954 7.57617C4.45533 7.47266 4.52954 7.32812 4.6565 7.32812H5.57251C5.77173 7.32812 5.96118 7.42383 6.07837 7.58789L7.469 9.51758L10.5393 5.25977C10.6565 5.09766 10.844 5 11.0452 5H11.9612C12.0881 5 12.1624 5.14453 12.0881 5.24805Z",
    fill: "#0DD490"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3254_1241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationFilled);
export default __webpack_public_path__ + "static/media/confirmation-filled.abde8e4df0097ee290a1f199c0af4fb4.svg";
export { ForwardRef as ReactComponent };